/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Author from 'ui/src/components/Author';
import Image from 'next/image';
import Link from 'next/link';
import { twMerge } from 'utilities/src/twMerge';

type PostAuthorProps = {
  imageUrl: string;
  imageSize: number;
  name: string;
  description: string;
  authorSlug: string;
  authorNameClasses?: string;
};

function PostAuthor({ imageUrl, imageSize, name, description, authorSlug, authorNameClasses }: PostAuthorProps) {
  return (
    <Author>
      <Author.Image>
        <Link href={`/author/${authorSlug}/`}>
          <Image
            alt={name}
            src={imageUrl}
            width={imageSize}
            height={imageSize}
            className="rounded-full"
            unoptimized
          />
        </Link>
      </Author.Image>
      <div className="mt-1 pl-3">
        <Link href={`/author/${authorSlug}/`}>
          <Author.Name classes={twMerge('mb-1 hover:underline', authorNameClasses)}>{name}</Author.Name>
        </Link>
        <Author.Description classes="text-site-neutrals-400 text-[0.9rem] leading-[1.125rem] text-site-neutrals-600 !text-[0.75rem] !leading-[1.125rem]">
          {description}
        </Author.Description>
      </div>
    </Author>
  );
}

export default PostAuthor;
